import { render } from "./MergeList.vue?vue&type=template&id=75e25e30"
import script from "./MergeList.vue?vue&type=script&lang=js"
export * from "./MergeList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__